/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_New_CategoryInputs */

const en_cases_settings_new_category = /** @type {(inputs: Cases_Settings_New_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New category`)
};

/**
* | output |
* | --- |
* | "New category" |
*
* @param {Cases_Settings_New_CategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cases_settings_new_category = /** @type {((inputs?: Cases_Settings_New_CategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_New_CategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_new_category(inputs)
});